export default 'https://tme.understood.org/assets/pencilcase.40bb1697.glb'